import type { DayWindowChoice } from 'app/filter.utils'

export const MAX_DAY_WINDOW_DAYS = 3650

/** The day window a stored `<kind>:<days>` rule value names, with its typed count. */
export function readDayWindow(
  dayWindows: ReadonlyArray<DayWindowChoice>,
  value: unknown,
): { choice: DayWindowChoice; days: string } | undefined {
  if (typeof value !== `string`) return undefined
  const [kind, days] = value.split(`:`)
  const choice = dayWindows.find((candidate) => candidate.kind === kind)
  return choice && days !== undefined ? { choice, days } : undefined
}
